/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Overview_Round_ManageInputs */



/**
* | output |
* | --- |
* | "Round {n} in progress. Manage scoring in the Rounds tab." |
*
* @param {Overview_Round_ManageInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const overview_round_manage = /** @type {((inputs: Overview_Round_ManageInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Overview_Round_ManageInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Ronde ${i?.n} en cours. Gérez le score dans l'onglet Rondes.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Ronda ${i?.n} en progreso. Gestione las puntuaciones en la pestaña Rondas.`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Rodada ${i?.n} em andamento. Gerencie a pontuação na aba Rodadas.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Round ${i?.n} in corso. Gestisci i punteggi nella scheda Round.`)
	return /** @type {LocalizedString} */ (`Round ${i?.n} in progress. Manage scoring in the Rounds tab.`)
});